import FourOFourComponent from "../Components/FourOFourComponent";

const FourOFourPage = () => {

    return (
        <div>
            <FourOFourComponent />
        </div>
    )
};

export default FourOFourPage;